import { Box, Button, Typography } from '@mui/material';
import { useStyles } from 'components/Styles';
import React from 'react';

export default function WelcomeText(props) {
  const { setStep } = props;
  const classes = useStyles();

  return (
    <>
      <Typography
        style={{
          marginBottom: '1rem', fontWeight: '700', fontSize: '36px', textAlign: 'center',
        }}
      >
        Falta pouco para começar a utilizar a plataforma!
      </Typography>
      <Box width="50%">
        <Button
          className={classes.roundedButton}
          variant="contained"
          size="large"
          onClick={() => {
            setStep((prev) => prev + 1);
          }}
          fullWidth
        >
          <Typography variant="button">Criar ciclo</Typography>
        </Button>
      </Box>
    </>
  );
}
